import React, { useState } from 'react';
import { getGender, getGermanLanguageLevel } from '@helpers/getGermanNaming';

import * as S from './styles';

interface Props {
  kid: any,
  paperProps?: any,
  handleClose: () => void,
  anchorEl: any,
  id: any
}

const KidHint = ({ kid, paperProps, handleClose, anchorEl }: Props) => {
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const getBooleanLabel = (obj, key) => {
    if (obj && obj[key]) {
      return 'ja';
    } else if (obj && !obj[key]) {
      return 'nein';
    }
  };

  return (
    <S.PopoverWrap
      PaperProps={paperProps}
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
    >
      <S.HintWrap>
        <S.HintHeader>SuS-Information</S.HintHeader>
        <S.HintRow>
          <S.HintItem>
            <p className="label">Name</p>
            <strong>{kid?.fullName || ''}</strong>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Adresse</p>
            <span>
              {kid.address}
            </span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Geschlecht</p>
            <span>{getGender(kid.gender)}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Geburtstag</p>
            <span>
              {kid.birthday}
            </span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">
              Deutsch
            </p>
            <span>
              {getGermanLanguageLevel(kid.germanLanguageLevel)}
            </span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">
              Umgangssprache
            </p>
            <span>
              {kid.motherLanguage}
            </span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Lehrperson</p>
            <span>{kid?.teacherName}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Schulbus</p>
            <span>{getBooleanLabel(kid, 'schoolBus')}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Erfahrung Betreuung</p>
            <span>{getBooleanLabel(kid, 'previousExperience')}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Notizen</p>
            <span>{kid?.note}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Wunsch</p>
            <span>{kid?.specialNote}</span>
          </S.HintItem>
        </S.HintRow>
      </S.HintWrap>
    </S.PopoverWrap>
  );
};

export default KidHint;
